import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { notificationDatabaseService } from '../../services/notificationDatabaseService';
import AppIcon from '../../components/AppIcon';

const listItemClass =
  'w-full flex items-center gap-4 p-4 rounded-xl border border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition-colors text-right';
const listIconClass =
  'w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0';
const listLabelClass = 'font-medium text-slate-800';

export default function AccountHub() {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    notificationDatabaseService.getMyNotifications()
      .then((data) => {
        const count = (data || []).filter((n) => !n.is_read && !n.isRead).length;
        setUnreadCount(count);
      })
      .catch(() => {});
  }, []);

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/customer-login');
    } catch (e) {
      console.error('Logout error:', e);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 space-y-4">
        <h2 className="text-xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
          حسابي
        </h2>
        <div className="grid gap-3">
          <button type="button" onClick={() => navigate('/customer-dashboard/profile')} className={listItemClass}>
            <div className={listIconClass}><AppIcon name="User" size={20} className="text-primary" /></div>
            <span className={listLabelClass}>الملف الشخصي</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </button>
          <button type="button" onClick={() => navigate('/customer-dashboard/my-deliveries')} className={listItemClass}>
            <div className={listIconClass}><AppIcon name="Images" size={20} className="text-primary" /></div>
            <span className={listLabelClass}>التسليمات</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </button>
          <button type="button" onClick={() => navigate('/customer-dashboard/settings')} className={listItemClass}>
            <div className={listIconClass}><AppIcon name="Settings" size={20} className="text-primary" /></div>
            <span className={listLabelClass}>الإعدادات</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </button>
          <button type="button" onClick={() => navigate('/customer-dashboard/notifications')} className={listItemClass}>
            <div className="relative flex-shrink-0">
              <div className={listIconClass}><AppIcon name="Bell" size={20} className="text-primary" /></div>
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1 leading-none shadow-sm">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </div>
            <span className={listLabelClass}>الإشعارات</span>
            {unreadCount > 0 && (
              <span className="px-2 py-0.5 bg-red-500 text-white text-xs font-bold rounded-full">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </button>
          <button type="button" onClick={handleLogout} className={listItemClass}>
            <div className={listIconClass}><AppIcon name="LogOut" size={20} className="text-slate-600" /></div>
            <span className={listLabelClass}>تسجيل خروج</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </button>
          <button type="button" onClick={() => navigate('/customer-dashboard/delete-account')} className={listItemClass + ' border-red-200 bg-red-50/50 hover:bg-red-50'}>
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0"><AppIcon name="Trash2" size={20} className="text-red-500" /></div>
            <span className={listLabelClass + ' text-red-700'}>حذف الحساب</span>
            <AppIcon name="ChevronLeft" size={18} className="text-red-400 mr-auto" />
          </button>
          <button type="button" onClick={() => navigate('/customer-dashboard/help')} className={listItemClass}>
            <div className={listIconClass}><AppIcon name="HelpCircle" size={20} className="text-primary" /></div>
            <span className={listLabelClass}>المساعدة</span>
            <AppIcon name="ChevronLeft" size={18} className="text-slate-400 mr-auto" />
          </button>
        </div>
      </div>
    </div>
  );
}
